var exports = {
  "k": "xe564cbfb--de6207--container",
};

module.exports = exports;
